import request from '@/utils/request';

const PATH = '/mypage';

export const getRecommendKeyword = (params: any) => request({
  url: `${PATH}/recommendKeyword`,
  method: 'get',
  params,
});
